<template>
  <div class="web-pages-hero-editing web-pages-editing-block">
    <div class="web-pages-universal-fields">
      <div class="form-input">
        <label>Image url</label>
        <input
          type="text"
          :value="selectedBlock.url"
          @input="
            $store.dispatch('webPages/handleBlockInput', {
              key: 'url',
              type: 'text',
              value: $event.target.value,
            })
          "
        />
      </div>
      <div class="form-input">
        <label>Alt text</label>
        <input
          type="text"
          :value="selectedBlock.alt"
          @input="
            $store.dispatch('webPages/handleBlockInput', {
              key: 'alt',
              type: 'text',
              value: $event.target.value,
            })
          "
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "WebPagesTextForm",
  data() {
    return {};
  },

  computed: {
    ...mapGetters("webPages", ["selectedBlock"]),
    ...mapGetters("languages", ["enabledLanguages"]),
  },
  mounted() {},
  methods: {},
};
</script>
